import { CommissionsPanel } from '@/features/finance/commissions';

/**
 * My Space → Commissions. Self-scoped server-side (the rep only ever sees their
 * own commissions); read-only here — pay-out/void is a finance-role action on
 * the HR side. Shows projected (while pending) vs actual (once the client pays).
 */
export function CabinetCommissionsPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">Commissions</h1>
      <CommissionsPanel canManage={false} />
    </div>
  );
}
